<template>
  <div>
    <v-dialog v-model="brokenObjectDialog" persistent max-width="600px">
      <template v-slot:activator="{ attrs }">
        <p
          id="brokenObjectForm"
          v-bind="attrs"
          @click="openBrokenObjectDialog"
        ></p>
      </template>
      <v-card v-if="objForm !== null">
        <v-card-title>
          <span class="text-h5">Tambah Data Bangunan/Mesin/Alat</span>
        </v-card-title>
        <v-form
          ref="brokenObjectFormRef"
          @submit.prevent="saveBrokenObject"
          :disabled="loading"
        >
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12" class="d-flex flex-column">
                  <p
                    class="text-left"
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Nama
                  </p>
                  <v-text-field
                    v-model="objForm.name"
                    :rules="rules.nameRules"
                    dense
                    outlined
                    style="height: 45px"
                  />
                </v-col>
                <v-col cols="6" class="d-flex flex-column">
                  <p
                    class="text-left"
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Kategori
                  </p>
                  <v-autocomplete
                    v-model="objForm.object_category"
                    :items="dropdown.category"
                    :rules="rules.categoryRules"
                    item-text="name"
                    item-value="id"
                    return-object
                    dense
                    outlined
                    clearable
                    style="height: 45px"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="3" class="d-flex flex-column">
                  <p
                    class="text-left"
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Qty
                  </p>
                  <v-text-field
                    v-model="objForm.qty"
                    dense
                    outlined
                    type="number"
                    :min="0"
                    style="height: 45px"
                  />
                </v-col>
                <v-col cols="6" class="d-flex flex-column">
                  <p
                    class="text-left"
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Satuan
                  </p>
                  <v-autocomplete
                    v-model="objForm.uom"
                    :items="dropdown.unit"
                    item-text="name"
                    item-value="id"
                    return-object
                    dense
                    outlined
                    clearable
                    style="height: 45px"
                  ></v-autocomplete>
                </v-col>
                <v-col cols="12" class="d-flex flex-column">
                  <p
                    class="text-left"
                    style="
                      margin: 0;
                      font-size: 12px;
                      font-weight: bold;
                      color: rgba(0, 0, 0, 0.5);
                    "
                  >
                    Keterangan
                  </p>
                  <v-textarea
                    v-model="objForm.description"
                    :auto-grow="true"
                    rows="3"
                    outlined
                    style="height: 45px"
                  />
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="red darken-1"
              :loading="loading"
              text
              type="button"
              @click="cancelSave"
            >
              Close
            </v-btn>
            <v-btn color="blue darken-1" :loading="loading" text type="submit">
              Save
            </v-btn>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
import buildType from '../../../../../../services/buildType'
export default {
  name: 'FormBrokenObject',
  props: ['loading', 'brokenObjectUpdateForm', 'inspectionreport'],
  data() {
    return {
      proc: buildType.apiURL('proc'),
      dssApi: buildType.apiURL('dss'),
      // hrsApi: buildType.apiURL('hrs'),
      brokenObjectDialog: false,
      objForm: null,
      dropdown: {
        category: [],
        unit: []
      },
      rules: {
        nameRules: [],
        categoryRules: []
      }
    }
  },
  computed: {
    ...mapGetters(['getUserProfile'])
  },
  methods: {
    onResize() {
      this.wWidth = window.innerWidth
    },
    async openBrokenObjectDialog() {
      this.$nextTick(() => {
        console.log('person dialog>>>', this.brokenObjectUpdateForm)
      })
      if (this.brokenObjectUpdateForm != null) {
        this.objForm = this.brokenObjectUpdateForm
      } else {
        this.objForm = {
          act: 'add',
          name: null,
          object_category: null,
          qty: null,
          uom: null,
          description: null
        }
      }
      this.initDropdown()

      console.log('objForm', this.objForm)
      setTimeout(() => {
        this.brokenObjectDialog = true
      }, 300)
    },
    cancelSave() {
      console.log('cancelSave')

      setTimeout(() => {
        this.$emit('saveBrokenObject', null)
        this.closeBrokenObjectDialog()
      }, 0)
    },
    closeBrokenObjectDialog() {
      this.$refs.brokenObjectFormRef.reset()
      setTimeout(() => {
        this.brokenObjectDialog = false
        setTimeout(() => {
          this.objForm = null
          this.dropdown.category = []
          this.dropdown.unit = []
        }, 200)
      }, 200)
    },
    saveBrokenObject() {
      this.rules.nameRules = [(v) => !!v || 'Kolom nama wajib di isi']
      this.rules.categoryRules = [(v) => !!v || 'Kolom kategori wajib di isi']
      const self = this
      setTimeout(function () {
        if (self.$refs.brokenObjectFormRef.validate()) {
          const newForm = {}
          Object.assign(newForm, self.objForm)
          self.$emit('saveBrokenObject', newForm)
          // self.closeBrokenObjectDialog();
          // self.createNewForm(newForm);
        }
      })
    },
    initDropdown() {
      this.getDropdownObjectCategory()
      this.getDropdownUnit()
      // this.getDropdownEmployee()
    },
    getDropdownObjectCategory() {
      const url = `${this.dssApi}master/universal/objectcategory/dropdown?keyword=`
      axios
        .get(url)
        .then((res) => {
          if (res.data.status_code === '00') {
            this.dropdown.category = res.data.data
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    getDropdownUnit() {
      axios
        .get(`${this.proc}master/unit/drop_down?keyword=`)
        .then((res) => {
          this.dropdown.unit = res.data.data
        })
        .catch((err) => {
          console.log(err)
        })
    },
    getCompanyAlias(id) {
      switch (id) {
        case 1:
          return 'TMP'
        case 2:
          return 'IMP'
        case 3:
          return 'GIT'
        case 4:
          return 'KAJ'
        case 5:
          return 'WIM'
        case 6:
          return 'SMI'
        case 7:
          return 'THP'
        case 8:
          return 'GAI'
        case 9:
          return 'GPP'
        case 10:
          return 'BWN'
        case 11:
          return 'INO'
        case 12:
          return 'BPS'
        case 13:
          return 'BPC'
        case 14:
          return 'WIMS'
        case 15:
          return 'BWI'
        case 16:
          return 'DAM'
        case 17:
          return 'PSR'
        case 18:
          return 'GAP'
        case 19:
          return 'SKH'
        case 20:
          return 'PTI'
        case 21:
          return 'BMS'
        case 22:
          return 'SDA'
      }
    },

    showMsgDialog(pModalType, pStatusMsg, pBtnCancel, yesBtn, noBtn, pText) {
      let additional = ''
      if (pText !== undefined) {
        additional = '<span style="font-size:12px;">' + pText + '</span>'
      }
      return new Promise((resolve) => {
        this.$swal
          .fire({
            position: 'center',
            icon: pModalType,
            html:
              '<strong style="font-size:18px;">' +
              pStatusMsg +
              '</strong>' +
              '<br/>' +
              additional,
            showConfirmButton: true,
            showCancelButton: pBtnCancel,
            confirmButtonText: yesBtn || 'OK',
            cancelButtonText: noBtn || 'NO'
          })
          .then((r) => {
            resolve(r)
          })
      })
    }
  }
}
</script>
